import "./RiepilogoPage.css";
import { t, getFullDateString, getFullHourAndMinute } from "../../../services/formatters";
import { useRiepilogoPage } from "./useRiepilogoPage";
import userIcon from "../../../assets/imgs/recap-user-icon.svg";
import calendarIcon from "../../../assets/imgs/recap-calendar-icon.svg";
import pinIcon from "../../../assets/imgs/recap-pin-icon.svg";
import actionMapIcon from "../../../assets/imgs/action-map-icon.svg";
import actionDirectionsIcon from "../../../assets/imgs/action-directions-icon.svg";
import actionPrintIcon from "../../../assets/imgs/action-print-icon.svg";
import actionPdfIcon from "../../../assets/imgs/action-pdf-icon.svg";
import actionCalendarIcon from "../../../assets/imgs/action-calendar-icon.svg";
import { Button } from "../../../components/Button";
import { AuditQuestion } from "../../../components/AuditQuestion";
import spinnerIcon from "../../../assets/imgs/spinner.gif";
import audits from "../../../config/audit.json";
import { useEffect } from "react";
import md5 from "blueimp-md5";
import sha256 from "crypto-js/sha256";

export const RiepilogoC5Page = () => {
    const {
        read,
        onShowMapClick,
        onGetDirectionsClick,
        onPrintClick,
        onDownloadPdfClick,
        onSaveToICalClick,
        auditSent,
        sendAuditAnswers,
        onAuditChange,
        isSendAuditError,
        isSendAuditBusy,
        askForEditAppointment,
        codiceFiscaleError,
        busy,
    } = useRiepilogoPage();

    useEffect(() => {
        let privacy_mtk_consent_string = "";
        let privacy_mtk_consent_array = [];
        if (read("privacyExtcommoffer") == "1") privacy_mtk_consent_array.push("Dati personali");
        if (read("privacyOtherservice") == "1") privacy_mtk_consent_array.push("Informativa");
        if (read("privacyProfilazione") == "1") privacy_mtk_consent_array.push("Societa terze");
        privacy_mtk_consent_string = privacy_mtk_consent_array.join(" - ");

        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: "/fa3/c5/fissa-appuntamento/thank-you-page",
            crmIdentification: read("utenteRiconosciuto") && read("utenteRiconosciuto") == true ? "utente riconosciuto" : "nuovo utente",
            privacy_mtk_consent: privacy_mtk_consent_string,
            funnelVersion: "nuovo",
            capFiliale: read("cap"),
            userID: read("contactID"),
            oppID: read("oppID"),
            // c_mdx: sha256(read("codiceFiscale") || "0").toString(),
            c_shx: sha256(read("codiceFiscale") || "0").toString(),
            // m_mdx: sha256(read("email") || "0").toString(),
            m_shx: sha256(read("email") || "0").toString(),
            // p_mdx: sha256(read("cellulare") || "0").toString(),
            p_shx: sha256(read("cellulare") || "0").toString(),
            presa_info: read("solo_info"),
        });
    }, []);

    return (
        <div id="riepilogo-page">
            {/* titolo */}
            {read("ricontatto") == false && (!read("ricontatto_external") || read("ricontatto_external") != "1") ? (
                <div className={`section page-title-component center-on-tablet`}>
                    <h1>{t("ti_aspettiamo")}</h1>
                    <div>{t("ecco_il_riepilogo")}</div>
                </div>
            ) : (
                <div className="section padding-x2 thank-you-text-extended-component text-center">
                    <p className="text-lg bold">{t("grazie_esteso")}</p>
                    <br />
                    <p>{t("sarai_contattato")}</p>
                </div>
            )}

            {/* recap */}
            {read("ricontatto") == false && (!read("ricontatto_external") || read("ricontatto_external") != "1") && (
                <>
                    <div className="appointment-recap-component white-box text-center">
                        <div className="section">
                            <img src={userIcon} />
                            <h3 className="semibold">
                                {read("nome")} {read("cognome")}
                            </h3>
                            <p>{read("email")}</p>
                            <p>{read("cellulare")}</p>
                        </div>
                        <div className="section">
                            <img src={calendarIcon} />
                            {read("dataScelta") && read("orarioScelto") && (
                                <h3 className="semibold">
                                    {getFullDateString(read("dataScelta").data)} - Ore {getFullHourAndMinute(read("orarioScelto").hour, read("orarioScelto").minute)}
                                </h3>
                            )}
                        </div>
                        <div className="section">
                            <img src={pinIcon} />
                            <h3 className="semibold">{read("filialeScelta").nomeFiliale}</h3>
                            <p>{read("filialeScelta").indirizzo}</p>
                        </div>
                    </div>

                    {/* icone azioni */}
                    <div className="section action-icons flex-row centered-content">
                        <div className="flex-cell">
                            <Button title={t("mostra_su_mappa")} onClick={onShowMapClick} aria={t("mostra_su_mappa")} iconSrc={actionMapIcon} />
                        </div>
                        <div className="flex-cell">
                            <Button title={t("ottieni_indicazioni")} onClick={onGetDirectionsClick} aria={t("ottieni_indicazioni")} iconSrc={actionDirectionsIcon} />
                        </div>
                        <div className="flex-cell">
                            <Button title={t("stampa")} aria={t("stampa")} onClick={onPrintClick} iconSrc={actionPrintIcon} />
                        </div>
                        <div className="flex-cell">
                            <Button title={t("scarica_pdf")} aria={t("scarica_pdf")} onClick={onDownloadPdfClick} iconSrc={actionPdfIcon} />
                        </div>
                        <div className="flex-cell">
                            <Button title={t("salva_in_calendario")} aria={t("salva_in_calendario")} onClick={onSaveToICalClick} iconSrc={actionCalendarIcon} />
                        </div>
                    </div>
                </>
            )}

            {/* modifica appuntamento appena fissato */}
            {(read("oppID") || read("oppID_external")) && (
                <div className="text-center">
                    <br />
                    <div
                        className={`section edit-appointment-link-component text-uppercase color-text-primary clickable ${busy ? "busy" : ""}`}
                        onClick={() => {
                            if (busy) return;
                            askForEditAppointment();
                        }}>
                        {t("modifica_appuntamento")}
                        <img className="state-icon" src={spinnerIcon} />
                        {codiceFiscaleError && (
                            <>
                                <br />
                                <p className="text-small error text-center text-no-transform">
                                    Non siamo riusciti a trovare il tuo appuntamento. <br /> Riprova, per favore.
                                </p>
                            </>
                        )}
                    </div>
                </div>
            )}

            <div className="appointment-recap-component white-box text-center" id="ricordadoc">
                <h3>{t("riepilogo_business_ricorda")}</h3>
                <div className="riepIcon">
                    <svg width="40" height="31" viewBox="0 0 40 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M33.2727 12.6979L25.2778 14.4425V8.02195L33.2727 6.27734V12.6979Z"
                            stroke="#ED1C24"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"></path>
                        <path d="M5.22217 6.27734L15.7777 8.38845" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M5.22217 10.2363L15.7777 12.3474" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M5.22217 14.1943L15.7777 16.3054" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M5.22217 18.1523L15.7777 20.2635" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M24.2222 18.9441L34.7777 16.833" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M5.22217 22.1113L15.7777 24.2224" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20 29.5L1 25.421V1L20 5.07898V29.5Z" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M39 25.421L20 29.5V5.07898L39 1V25.421Z"
                            stroke="#ED1C24"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"></path>
                        <path d="M24.2222 23.1668L34.7777 21.0557" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <p>Documento di riconoscimento in corso di validit&agrave;</p>
                <div className="riepIcon">
                    <svg width="40" height="23" viewBox="0 0 40 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M35.1126 22H4.88736C2.74943 22 1 20.2438 1 18.0977V4.90231C1 2.75615 2.74943 1 4.88736 1H35.1126C37.2506 1 39 2.75615 39 4.90231V18.0977C39 20.2438 37.2506 22 35.1126 22Z"
                            stroke="#ED1C24"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 14H14V5H5V14Z" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M18.7651 5H35" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M18.7651 9H35" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M5 18H35" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <p>Carta Regionale/Nazionale dei Servizi (Tessera Sanitaria)</p>
                <div className="riepIcon">
                    <svg width="40" height="31" viewBox="0 0 40 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 30H31V1H9V30Z" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M13.1904 5H26.8095" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M13.1904 9H26.8095" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M13.1904 13H26.8095" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M13.1904 17H26.8095" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M13.1904 21H26.8095" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M13.1904 25H26.8095" stroke="#ED1C24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <p>Copia del giustificativo di reddito in possesso al richiedente</p>
            </div>
        </div>
    );
};
